import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../api'

export const useUser = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: apiClient.user.fetchUserInfo,
    // Auth/superuser state must never be served stale: the persisted copy
    // hydrates instantly for fast first paint, but we always revalidate
    // against the backend on mount so a changed is_superuser flag propagates.
    staleTime: 0,
    refetchOnMount: 'always',
    gcTime: 1000 * 60 * 60 * 24, // Keep in memory for 24 hours
    retry: (failureCount, error) => {
      return failureCount < 3
    },
  })
}
